import { render } from "./ResetPassword.vue?vue&type=template&id=75dc818d&scoped=true&ts=true"
import script from "./ResetPassword.vue?vue&type=script&lang=ts"
export * from "./ResetPassword.vue?vue&type=script&lang=ts"

import "../assets/scss/sign-in.scss?vue&type=style&index=0&id=75dc818d&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75dc818d"]])

export default __exports__